/**
 * OSS文件上传模块
 */
import {getLoginId} from './Common.js'
import AppConfig from '../../config/AppConfig.js'
import axios from 'axios'
import OSS from 'ali-oss'

export default{
	// oss密钥缓存字段
	oss_cache_key: 'yswl_oss',
	// oss基本配置
	wanUrl: '',
	root: 'uploads',
	// 图片处理
	thumb90: 'thumb_90',
	thumbW200: 'thumb_w200',
	// 允许的后缀
	allowSuffix: ['jpg','png','jpeg','gif','mp4','mp3'],
	// 文件类型对应关系
	fileType2Suffix: {
		"text/plain":'txt',
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":'xlsx',
		"image/png":'png',
		"video/mp4":'mp4',
		"image/jpeg":'jpg',
		"image/gif":'gif',
		"audio/mp3":'mp3',
	 },
	 // OSS相关模块-获取密钥
	 requestKS(callback){
		let _this = this;
		// 读取缓存
		let cacheParam = localStorage.getItem(_this.oss_cache_key);
		if (cacheParam !== null){
			 cacheParam = JSON.parse(cacheParam);
			 if(new Date(cacheParam.expiration).getTime() > new Date().getTime()){
				 let client = new OSS(cacheParam);
				 _this.wanUrl = cacheParam.wanUrl;
				 // 回调
				 callback(client);
				 return;
			 }
		 }
		 // 重新获取
		 axios.get(AppConfig.host+'/api/api/getOssConfig?weiI=browser-'+getLoginId()).then(function(data){
			 if(data.status !== 200){
				 callback(false);
				 return false;
			 }
			 let result = data.data
			 let param = {
				accessKeyId: result.AccessKeyId,
				accessKeySecret: result.AccessKeySecret,
				stsToken: result.SecurityToken,
				endpoint: result.endpoint,
				bucket: result.bucket,
				expiration:result.Expiration,
				wanUrl:result.wanUrl,
			 };
			 let client = new OSS(param);
			 _this.wanUrl = result.wanUrl;
			 // 缓存数据
			 localStorage.setItem(_this.oss_cache_key,JSON.stringify(param));
			 // 回调
			 callback(client);
		 },function(error){
			 callback(false)
			 return false
		 })
	 },
	 
	 // OSS相关模块-上传文件-多文件
	 uploads(files,dir,thumb,callback,__this) {
		 let u_res = [];
		 let imgSuffix = ['jpg','png','jpeg'];
		 if (!files instanceof FileList){
			 callback(u_res);
			 return;
		 }
		 if (thumb === undefined || thumb === ""){
			 thumb = this.thumb90;
		 }
		 if (dir === undefined || dir === ""){
			 dir = 'images';
		 }
		 let _this = this;
		 this.requestKS(client=>{
			 // 同步执行上传
			 let promise = Promise.resolve();
			 for (let i = 0;i<files.length;i++){
				 promise = promise.then(()=>{
					 return new Promise((resolve, reject)=>{
						 let file = files[i];
						 let suffix = this.fileType2Suffix[file.type];
						 if (this.allowSuffix.indexOf(suffix) === -1) {
							 u_res.push({
								 code:0,
								 msg:'上传失败，文件后缀不支持'
							 });
							 resolve();
							 return;
						 }
						 let filePath = this.createPath(suffix,dir);
						 //filePath表示上传的object name , file表示上传的文件
						 client.multipartUpload(filePath, file,{}).then(function (oss_result) {
							 let code = 0;
							 let msg = '上传失败，服务器异常';
							 let path = _this.wanUrl + filePath;
							 let thumbSave = path;
							 if (imgSuffix.indexOf(suffix) !== -1){
								 thumbSave = path + '?x-oss-process=style/' + thumb;
							 }
							 if (oss_result.res !== undefined && oss_result.res.status === 200 && oss_result.res.statusCode === 200){
								 code = 1;
								 msg = '上传成功';
							 }
							 u_res.push({
								 code:code,
								 msg:msg,
								 path:path,
								 thumb:thumbSave
							 });
							 resolve();
						 }).catch(function (err) {
							 console.error(err);
							 u_res.push({
								 code:0,
								 msg:'上传失败，服务器异常'
							 });
							 resolve();
						 });
					 })
				 })
			 }
			 promise.then((resolve, reject)=>{
				 /* if (__this !== undefined){
					 $(__this).val("");
				 } */
				 callback(u_res)
			 })
		 });
	 },
	 
	 // OSS相关模块-上传文件-单文件
	 upload(file,dir,thumb,callback,__this) {
		 let imgSuffix = ['jpg','png','jpeg'];
		 if (!file instanceof File){
			 callback(u_res);
			 return;
		 }
		 if (thumb === undefined || thumb === ""){
			 thumb = this.thumb90;
		 }
		 if (dir === undefined || dir === ""){
			 dir = 'images';
		 }
		 let _this = this;
		 this.requestKS(client=>{
			 let suffix = this.fileType2Suffix[file.type];
			 if (this.allowSuffix.indexOf(suffix) === -1) {
				 callback({
					 code:0,
					 msg:'上传失败，文件后缀不支持'
				 });
			 }
			 let filePath = this.createPath(suffix,dir);
			 //filePath表示上传的object name , file表示上传的文件
			 client.multipartUpload(filePath, file,{}).then(function (oss_result) {
				 let code = 0;
				 let msg = '上传失败，服务器异常';
				 let path = _this.wanUrl + filePath;
				 let thumbSave = path;
				 if (imgSuffix.indexOf(suffix) !== -1){
					 thumbSave = path + '?x-oss-process=' + thumb;
				 }
				 if (oss_result.res !== undefined && oss_result.res.status === 200 && oss_result.res.statusCode === 200){
					 code = 1;
					 msg = '上传成功';
				 }
				callback({
					 code:code,
					 msg:msg,
					 path:path,
					 thumb:thumbSave
				 });
			 }).catch(function (err) {
				 console.error(err);
				 callback({
					 code:0,
					 msg:'上传失败，服务器异常'
				 });
			 });
		 });
	 },
	 
	// 上传聊天文件-普通聊天文件
	 uploadsChatting(files,callback,_this) {
		 this.uploads(files,'chatting',this.thumbW200,callback,_this)
	 },
 
	 // 上传聊天文件-群聊天文件
	 uploadsClusterChatting(files,callback,_this) {
		 this.uploads(files,'cluster_chatting',this.thumbW200,callback,_this)
	 },
 
	 // 上传朋友圈模板文件
	 uploadsCircle(files,callback,_this) {
		 this.uploads(files,'image/circle',this.thumb90,callback,_this)
	 },
 
	 // 上传朋友圈动态模板文件
	 uploadsDynamic(files,callback,_this) {
		 this.uploads(files,'image/dynamic',this.thumb90,callback,_this)
	 },
	 
	 // 上传聊天文件-普通聊天文件
	 uploadBase64Chatting(base64,callback,_this) {
		 this.upload(this.base64ToFile(base64),'chatting',this.thumbW200,callback,_this)
	 },
	 
	 // base64转File
	 base64ToFile(base64){
		let arr = base64.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
		while(n--){
		   u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], (new Date).getTime()+'.png', {type:mime});
	 },
 
	 // OSS相关模块-生成上传文件路径
	 createPath(suffix,dir) {
		 if (suffix === undefined || suffix === ''){
			 suffix = 'jpg';
		 }
		 if (dir === undefined || dir === ''){
			 dir = 'files';
		 }
		 let date = new Date();
		 let month = date.getMonth() + 1;
		 let day  = date.getDate();
		 if (month < 10){
			 month = '0'+month;
		 }
		 if (day < 10){
			 day =  '0' + day;
		 }
		 let file_name = (date.getTime() + '_' + this.random(10000,99999)).split('').reverse().join('');
		 return this.root + '/' + dir + '/' + date.getFullYear() + month + '/' + day + '/' + file_name + '.' + suffix;
	 },
	 	 
	 // OSS相关模块-生成随机数
	 random(min,max) {
		 return Math.ceil(Math.random() * (max - min)) + min;
	 }
}